import React from 'react';
import DetailSeminarRegistered from '../../containers/SeminarRegisteredManagermentViewer/DetailSeminarRegistered';

const ListSeminarPreview = () => (
    <DetailSeminarRegistered />
);

export default ListSeminarPreview;
